export default __webpack_public_path__ + "static/media/carousel-img-6.57fac480.png";